import React from "react";
import Checkbox from "../checkbox";
import {CheckboxProps} from "antd/lib/checkbox";
import Group from "./Group";
import "@whalecloud/fdx-theme-fdx/check-item.less";


export interface LACProps extends CheckboxProps {
    label: string;
}

export interface LAState {
    checked?:boolean;
}

class CheckItem extends React.Component<LACProps, LAState> {
  
  static Group: typeof Group;
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked||props.defaultChecked
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if ("checked" in nextProps) {
      return {
        checked: nextProps.checked
      };
    }
    return null;
  }

  handelChange = e => {
    const { onChange } = this.props;
    const { checked } = e.target;
    if (onChange) {
      onChange(e);
    }
    this.setState({ checked });
  };

  render() {
    const { label } = this.props;
    const { checked } = this.state;
    return (
      <span className="check-item">
        <Checkbox
          {...this.props}
          checked={checked}
          className={checked ? "input inputSelected" : "input"}
          onChange={this.handelChange}
        />
        <span className="innerWrapTop">{label}</span>
        <span className="innerWrapBtm">{label}</span>
      </span>
    );
  }
}

CheckItem.Group= Group;
export default CheckItem;



// WEBPACK FOOTER //
// ./src/components/check-item/index.tsx